import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-expansion-card',
    templateUrl: './expansion-card.component.html',
    styleUrls: ['./expansion-card.component.scss']
})
export class ExpansionCardComponent extends BaseViewComponent implements OnInit {

    @ViewChild('panel', {static: true}) expansionPanel!: MatExpansionPanel;

    @Input() startExpanded!: boolean;
    @Input() hideBorder: boolean = false;
    @Input() hasBackground: boolean = false;
    @Input() hasHeaderPadding: boolean = true;
    @Input() qaTag: string = '';
    @Input() hasHeaderBottomBorder: boolean = false;
    @Input() hasHorizontalPadding: boolean = true;

    @Output() panelStatus: EventEmitter<boolean> = new EventEmitter();

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.startExpanded) {
            this.expansionPanel.open();
        }
    }

    TogglePanel(expanded: boolean): void {
        this.panelStatus.emit(expanded);
    }

    get isCardExpanded(): boolean {
        return this.expansionPanel.expanded;
    }
}
